var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-left"},[_c('span',{staticClass:"text-primary"},[_vm._v(_vm._s(_vm.primaryLabel))]),_c('br'),_c('span',{staticClass:"text-secondary"},[_vm._v(_vm._s(_vm.getSecondaryLabel))]),_c('br'),(_vm.tertiaryLabel)?_c('span',{staticClass:"text-secondary"},[_vm._v(_vm._s(_vm.tertiaryLabel))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }